import React, { Fragment } from "react";
import { connect } from "react-redux";
import {
  useResolvedPath,
  useMatch,
  NavLink,
  useLocation,
  matchPath,
} from "react-router-dom";
import { AppSettings } from "./../../config/app-settings.js";
import menuSAdmin from "./../../config/app-menu.jsx";
import menuCustomerService from "./../../config/app-menuCustomerService.jsx";
import menuMod from "./../../config/app-menuMod.jsx";
import menuAccountant from "./../../config/app-menuAccountant.jsx";
import menuCompany from "./../../config/app-menuCompany.jsx";
import menuSupervisor from "./../../config/app-menuSupervisor.jsx";
import menuOperator from "./../../config/app-menuOperator.jsx";

import auth from "../../services/authservice";
import http from "../../services/httpService";
import { loadCurrentUser } from "./../../store/users";
import { loadCurrentCompany } from "./../../store/companies.js";
import {
  fetchTicketCount,
  fetchUserCount,
  fetchForumCount,
  fetchWorkInstructionCount,
} from "../../store/count.js";

const apiUrl = process.env.REACT_APP_API_URL;

function NavItem({ menu, ...props }) {
  let resolved = useResolvedPath(menu.path);
  let match = useMatch({ path: resolved.pathname });

  let location = useLocation();
  let match2 = matchPath({ path: menu.path, end: false }, location.pathname);

  let icon = menu.icon && (
    <div className="menu-icon">
      <i className={menu.icon}></i>
    </div>
  );
  let img = menu.img && (
    <div className="menu-icon-img">
      <img src={menu.img} alt="" />
    </div>
  );
  let caret = menu.children && !menu.badge && (
    <div className="menu-caret"></div>
  );
  let label = menu.label && (
    <span className="menu-label ms-5px">{menu.label}</span>
  );
  let badge = menu.badge && <div className="menu-badge">{menu.badge}</div>;
  let highlight = menu.highlight && (
    <i className="fa fa-paper-plane text-theme"></i>
  );
  let title = menu.title && (
    <div className="menu-text">
      {menu.title} {label} {highlight}
    </div>
  );

  return (
    <div
      className={
        "menu-item" +
        (match || match2 ? " active" : "") +
        (menu.children ? " has-sub" : "")
      }
    >
      <NavLink className="menu-link" to={menu.path} {...props}>
        {img} {icon} {title}
        {caret} {badge}
      </NavLink>

      {menu.children && (
        <div className="menu-submenu">
          {menu.children.map((submenu, i) => (
            <NavItem key={i} menu={submenu} />
          ))}
        </div>
      )}
    </div>
  );
}

class SidebarNav extends React.Component {
  static contextType = AppSettings;

  constructor(props) {
    super(props);
    this.state = {
      menus: [],
      currentUser: {},
      loading: true,
      permissions: [],
    };
    this.handleSidebarSearch = this.handleSidebarSearch.bind(this);
  }

  async getRoles() {
    try {
      const { data: userRoles } = await http.get(apiUrl + "/userroles");
      const permissions = {
        path: "/user/permissions",
        title: "UserRoles Permissions",
        children: userRoles.map((role) => ({
          path: `/user/permissions/${role._id}`,
          title: role.name,
        })),
      };

      // Update the menus state to include permissions
      this.setState((prevState) => ({
        menus: prevState.menus.map((item) => {
          if (item.path === "/Users") {
            return {
              ...item,
              children: [permissions, ...(item.children || [])],
            };
          }
          return item;
        }),
      }));
    } catch (error) {
      console.error("Failed to fetch roles:", error);
    }
  }

  async componentDidMount() {
    const user = auth.getProfile();
    if (user) {
      try {
        // Load current user first
        await this.props.loadCurrentUser(user._id);

        const { currentUser } = this.props;
        if(currentUser.role.name === "Company") await this.props.loadCurrentCompany(currentUser.accountNo);

        // Fetch counts individually
        this.props.fetchUserCount();
        this.props.fetchTicketCount();
        this.props.fetchForumCount();
        this.props.fetchWorkInstructionCount();
        if(this.props.currentUser.role.name === "Company") await this.props.loadCurrentCompany(user.accountNo);

        this.updateMenusWithUserRole();
      } catch (error) {
        console.error("Error loading user:", error);
        this.setState({ loading: false });
      }
    }
  }

  componentDidUpdate(prevProps) {
    // Update menus when currentUser or counts change
    if (
      prevProps.currentUser !== this.props.currentUser ||
      prevProps.userCount !== this.props.userCount ||
      prevProps.ticketCount !== this.props.ticketCount ||
      prevProps.forumCount !== this.props.forumCount ||
      prevProps.workInstructionCount !== this.props.workInstructionCount||
      prevProps.currentCompany !== this.props.currentCompany 
    ) {
      this.updateMenusWithUserRole();
    }
  }

  updateMenusWithUserRole() {
    const {
      currentUser,
      currentCompany,
      userCount,
      ticketCount,
      forumCount,
      workInstructionCount,
    } = this.props;
    if (!currentUser || !currentUser.role) {
      this.setState({ loading: false });
      return;
    }
    let menus = [];
    const roleName = currentUser.role?.name;

    switch (roleName) {
      case "Supervisor":
        menus = menuSupervisor;
        break;
      case "Operator":
        menus = menuOperator;
        break;
      case "Company":
        //menus = currentUser.accountNo?.isMaster ? menuSAdmin : menuCompany;
  //        let isMaster = false;
  // if (Array.isArray(currentCompany) && currentCompany.length > 0) {
  //   isMaster = currentCompany[0].isMaster || false;
  // }
        menus = currentCompany[0]?.isMaster ? menuSAdmin : menuCompany;
        break;
      case "Accountant":
        menus = menuAccountant;
        break;
      case "CustomerService":
        menus = menuCustomerService;
        break;
      case "Mod":
        menus = menuMod;
        break;
      default:
        menus = [];
    }

    // Update the badges with actual counts
    const updatedMenus = menus.map((menu) => {
      const updatedMenu = { ...menu };

      if (menu.path === "/user") {
        updatedMenu.badge = userCount > 0 ? userCount.toString() : "0";
      }
      if (menu.path === "/Ticket") {
        updatedMenu.badge = ticketCount > 0 ? ticketCount.toString() : "0";
      }
      if (menu.path === "/Forum") {
        updatedMenu.badge = forumCount > 0 ? forumCount.toString() : "0";
      }
      if (menu.path === "/workinstructions") {
        updatedMenu.badge =
          workInstructionCount > 0 ? workInstructionCount.toString() : "0";
      }

      return updatedMenu;
    });

    this.setState({
      menus: updatedMenus,
      currentUser: currentUser,
      loading: false,
    });

    // Load roles after setting up menus
    this.getRoles();
  }

  handleSidebarSearch(e) {
    let targetValue = e.target.value;
    targetValue = targetValue.toLowerCase();

    if (targetValue) {
      var elms = [].slice.call(
        document.querySelectorAll(
          ".app-sidebar:not(.app-sidebar-end) .menu > .menu-item:not(.menu-profile):not(.menu-header):not(.menu-search), .app-sidebar:not(.app-sidebar-end) .menu-submenu > .menu-item"
        )
      );
      if (elms) {
        elms.map(function (elm) {
          elm.classList.add("d-none");
          return true;
        });
      }
      var elms2 = [].slice.call(
        document.querySelectorAll(
          ".app-sidebar:not(.app-sidebar-end) .has-text"
        )
      );
      if (elms2) {
        elms2.map(function (elm) {
          elm.classList.remove("has-text");
          return true;
        });
      }
      var elms3 = [].slice.call(
        document.querySelectorAll(".app-sidebar:not(.app-sidebar-end) .expand")
      );
      if (elms3) {
        elms3.map(function (elm) {
          elm.classList.remove("expand");
          return true;
        });
      }
      var elms4 = [].slice.call(
        document.querySelectorAll(
          ".app-sidebar:not(.app-sidebar-end) .menu > .menu-item:not(.menu-profile):not(.menu-header):not(.menu-search) > .menu-link, .app-sidebar .menu-submenu > .menu-item > .menu-link"
        )
      );
      if (elms4) {
        elms4.map(function (elm) {
          var targetText = elm.textContent;
          targetText = targetText.toLowerCase();
          if (targetText.search(targetValue) > -1) {
            var targetElm = elm.closest(".menu-item");
            if (targetElm) {
              targetElm.classList.remove("d-none");
              targetElm.classList.add("has-text");
            }

            var targetElm2 = elm.closest(".menu-item.has-sub");
            if (targetElm2) {
              var targetElm3 = targetElm.querySelector(
                ".menu-submenu .menu-item.d-none"
              );
              if (targetElm3) {
                targetElm3.classList.remove("d-none");
              }
            }

            var targetElm4 = elm.closest(".menu-submenu");
            if (targetElm4) {
              targetElm4.style.display = "block";

              var targetElm5 = targetElm.querySelector(
                ".menu-item:not(.has-text)"
              );
              if (targetElm5) {
                targetElm5.classList.add("d-none");
              }

              var targetElm6 = elm.closest(".has-sub:not(.has-text)");
              if (targetElm6) {
                targetElm6.classList.remove("d-none");
                targetElm6.classList.add("expand");

                var targetElm7 = targetElm.closest(".has-sub:not(.has-text)");
                if (targetElm7) {
                  targetElm7.classList.remove("d-none");
                  targetElm7.classList.add("expand");
                }
              }
            }
          }
          return true;
        });
      }
    } else {
      var elms5 = [].slice.call(
        document.querySelectorAll(
          ".app-sidebar:not(.app-sidebar-end) .menu > .menu-item:not(.menu-profile):not(.menu-header):not(.menu-search).has-sub .menu-submenu"
        )
      );
      if (elms5) {
        elms5.map(function (elm) {
          elm.removeAttribute("style");
          return true;
        });
      }

      var elms6 = [].slice.call(
        document.querySelectorAll(
          ".app-sidebar:not(.app-sidebar-end) .menu > .menu-item:not(.menu-profile):not(.menu-header):not(.menu-search)"
        )
      );
      if (elms6) {
        elms6.map(function (elm) {
          elm.classList.remove("d-none");
          return true;
        });
      }

      var elms7 = [].slice.call(
        document.querySelectorAll(
          ".app-sidebar:not(.app-sidebar-end) .menu-submenu > .menu-item"
        )
      );
      if (elms7) {
        elms7.map(function (elm) {
          elm.classList.remove("d-none");
          return true;
        });
      }

      var elms8 = [].slice.call(
        document.querySelectorAll(".app-sidebar:not(.app-sidebar-end) .expand")
      );
      if (elms8) {
        elms8.map(function (elm) {
          elm.classList.remove("expand");
          return true;
        });
      }
    }
  }

  shouldAccessSideNavItem(item) {
    if (!this.state.loading && this.state.currentUser) {
      if (item === "Dashboard") {
        return true;
      } else {
        const permissions =
          this.state.currentUser?.role?.Permissions?.Permissions;
        if (permissions && permissions.length > 0) {
          for (let i = 0; i < permissions.length; i++) {
            let module = permissions[i].module?.name;
            if (item === module) {
              return permissions[i].read;
            }
          }
        }
        return true;
      }
    }
    return false;
  }

  render() {
    if (this.state.loading) {
      return (
        <div className="menu">
          <div className="menu-header">Loading...</div>
        </div>
      );
    }

    return (
      <div className="menu">
        {this.context.appSidebarSearch && (
          <div className="menu-search mb-n3">
            <input
              type="text"
              className="form-control"
              placeholder="Sidebar menu filter..."
              onKeyUp={this.handleSidebarSearch}
            />
          </div>
        )}
        <div className="menu-header">Navigation</div>
        {this.state.menus && this.state.menus.length > 0 ? (
          this.state.menus.map((menu, i) => (
            <Fragment key={i}>
              {this.shouldAccessSideNavItem(menu.title) && (
                <NavItem key={i} menu={menu} />
              )}
            </Fragment>
          ))
        ) : (
          <div className="menu-item">
            <div className="menu-text">No menu items available</div>
          </div>
        )}
      </div>
    );
  }
}

// Fixed mapStateToProps - corrected the state path
const mapStateToProps = (state) => ({
  currentUser: state.entities.users.currentUser,
  currentCompany: state.entities.companies.currentCompany,
  ticketCount: state.entities.count.ticketCount,
  userCount: state.entities.count.userCount,
  forumCount: state.entities.count.forumCount,
  workInstructionCount: state.entities.count.workInstructionCount,
});

const mapDispatchToProps = (dispatch) => ({
  loadCurrentUser: (id) => dispatch(loadCurrentUser(id)),
  loadCurrentCompany: (id) => dispatch(loadCurrentCompany(id)),
  fetchUserCount: () => dispatch(fetchUserCount()),
  fetchTicketCount: () => dispatch(fetchTicketCount()),
  fetchForumCount: () => dispatch(fetchForumCount()),
  fetchWorkInstructionCount: () => dispatch(fetchWorkInstructionCount()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SidebarNav);
